import './index.less';
import * as React from 'react';
import cx from 'classnames';

const styles = require('./index.less');

const TAB_ITEMS = [
  {
    routeKey: 'RULES',
    positionClassName: styles.group5,
    hitClassName: styles.tabRules,
    tabName: 'tab-3-活动规则',
    defaultClassName: styles.layer9,
    defaultName: 'tab-3-默认态',
    activeClassName: styles.layer10,
    activeName: 'tab-3-激活态'
  },
  {
    routeKey: 'BACKPACK',
    positionClassName: styles.group6,
    hitClassName: styles.tabBackpack,
    tabName: 'tab-2-我的背包',
    defaultClassName: styles.layer11,
    defaultName: 'tab-2-默认态',
    activeClassName: styles.layer12,
    activeName: 'tab-2-激活态'
  },
  {
    routeKey: 'TEAM',
    positionClassName: styles.group7,
    hitClassName: styles.tabTeam,
    tabName: 'tab-1-组队集结',
    defaultClassName: styles.layer13,
    defaultName: 'tab-1-默认态',
    activeClassName: styles.layer14,
    activeName: 'tab-1-激活态'
  }
];

const MoBottomTabs = ({ className, activeRouteKey = null, disabled = false, onNavigate }) => {
  const handleNavigate = routeKey => () => {
    if (disabled) {
      return;
    }

    onNavigate?.(routeKey);
  };

  return (
    <div className={cx(styles.group4, className)} data-name="通用组件 - 底部三tab组" role="tablist" aria-disabled={!!disabled}>
      {TAB_ITEMS.map(item => {
        const isActive = activeRouteKey === item.routeKey;

        return (
          <div
            key={item.routeKey}
            className={cx(item.positionClassName, styles.tabHitArea, item.hitClassName, disabled && styles.tabHitAreaDisabled)}
            data-name={item.tabName}
            data-route-key={item.routeKey}
            role="tab"
            aria-selected={isActive}
            aria-disabled={!!disabled}
            onClick={handleNavigate(item.routeKey)}
          >
            <div
              className={cx(item.defaultClassName, isActive ? styles.hiddenStateLayer : styles.visibleStateLayer)}
              data-name={item.defaultName}
              data-route-key={item.routeKey}
              data-tab-state="default"
              aria-hidden={isActive}
            />
            <div
              className={cx(item.activeClassName, isActive ? styles.visibleStateLayer : styles.hiddenStateLayer)}
              data-name={item.activeName}
              data-route-key={item.routeKey}
              data-tab-state="active"
              aria-hidden={!isActive}
            />
          </div>
        );
      })}
    </div>
  );
};

export default MoBottomTabs;
